// Landing page copy in Turkish, English and Serbian (Latin).
export const landingCopy = {
  tr: {
    nav: { how: "Nasıl çalışır", features: "Özellikler", pricing: "Fiyat", faq: "SSS", login: "Otel girişi", demo: "Demo iste" },
    mock: {
      welcome: "Hoş geldiniz", hotel: "Örnek Otel", q: "Konaklamanız nasıl geçiyor?", word: "Beklentinin altında",
      msg: "Klima çalışmıyor, oda çok sıcak.", send: "Resepsiyona gönder", live: "CANLI", now: "şimdi", room: "Oda",
      qr: "OKUT · PUANLA", google: "Yeni Google yorumu", monogram: "Ö",
    },
    hero: {
      chip: "Oteller için misafir geri bildirim sistemi",
      title: ["Sorunu misafir ", "otelden ayrılmadan", " çözün."],
      lede: "Odadaki QR kodu okutan misafir 10 saniyede puan verir. Memnun olmayanın mesajı anında resepsiyon ekranına düşer; memnun olan tek dokunuşla Google'da yorum bırakır.",
      cta: "Ücretsiz demo iste", try: "Misafir ekranını dene",
      ticks: ["Aynı gün kurulum", "Misafire uygulama indirtmez", "Türkçe · İngilizce · Sırpça"],
    },
    problem: {
      eyebrow: "Sorun",
      title: ["Memnun olmayan misafir genelde ", "resepsiyona değil", ", internete yazar."],
      items: [
        ["Check-out'ta her şey yolunda görünür", "Yüz yüze şikâyet etmek istemeyen misafir sessizce ayrılır."],
        ["Sorunu yorumdan öğrenirsiniz", "Düzeltme şansı geçtikten sonra, herkesin görebileceği bir yerde."],
        ["Memnun misafir yorum yazmayı unutur", "En iyi deneyimler Google'a hiç ulaşmaz."],
      ],
    },
    how: {
      eyebrow: "Nasıl çalışır", title: ["Dört adım, ", "sıfır", " eğitim."],
      steps: [
        ["Odada QR", "Her odaya o odaya özel QR stand konur. Misafir telefon kamerasıyla okutur; uygulama indirmez."],
        ["10 saniyede puan", "Misafir 1–5 arası puan verir. Oda numarası QR'dan otomatik gelir."],
        ["Sorun anında size", "1–3 puan ve mesaj, sesli uyarıyla resepsiyon paneline düşer. Misafir hâlâ oteldeyken çözersiniz."],
        ["Memnun misafir Google'a", "4–5 puan veren misafir tek dokunuşla otelinizin Google yorum sayfasına gider."],
      ],
    },
    features: {
      eyebrow: "Özellikler", title: ["Resepsiyonun ", "yeni kulağı."],
      lede: "Panel bir tarayıcı sekmesinde açık durur. Düşük puan geldiğinde ses çıkar, oda numarası ve misafirin mesajı ekrana gelir. Çözdüğünüzde tek tıkla kapatırsınız.",
      cta: "Panelin demosunu görün",
      items: [
        ["Sesli canlı uyarı", "Düşük puan geldiğinde panel ses çalar ve oda numarasını gösterir."],
        ["Odaya özel bağlantı", "Hangi odadan geldiğini sormanıza gerek kalmaz."],
        ["Üç dil", "Türkçe, İngilizce ve Sırpça. Misafirin telefon diline göre açılır."],
        ["Otel paneli", "Ortalama puan, açık ve çözülen talepler tek ekranda."],
        ["Uygulama yok", "Misafir için tarayıcıda açılır; personel için de kurulum gerektirmez."],
        ["Kurallara uygun", "Her misafir istediği an Google'da yorum yazabilir; yorumlar filtrelenmez."],
      ],
    },
    policy: ["Google kurallarına uygun.", " RateGuard yorumları filtrelemez; her misafir istediği an Google'da yorum yazabilir. Yaptığımız tek şey memnun olmayan misafirin sesini önce size ulaştırmak."],
    pricing: {
      eyebrow: "Fiyat", title: ["Tek paket, ", "her şey dahil."],
      chip: "Tüm özellikler",
      bullets: ["Tüm odalar için QR kodlar", "Canlı resepsiyon paneli ve sesli uyarı", "Google yorum yönlendirmesi", "Türkçe, İngilizce ve Sırpça misafir ekranı", "Kurulum ve QR tasarımı dahil", "Taahhüt yok, istediğiniz ay bırakın"],
      badges: ["30 gün koşulsuz iade garantisi", "Yıllık ödemede 2 ay bedava"],
      cta: "Demo isteyin",
    },
    faq: {
      eyebrow: "SSS", title: "Sık sorulanlar",
      items: [
        ["Kötü yorumları Google'dan gizliyor musunuz?", "Hayır. Google'ın kuralları yorumların seçerek toplanmasını yasaklar; RateGuard da bunu yapmaz. Düşük puan veren misafir de Google'a bağlantıyı görür. Fark şu: misafirin sorunu önce size ulaşır ve otelden ayrılmadan çözebilirsiniz."],
        ["Fiyata neler dahil?", "Her şey: QR kodların tasarımı, kurulum, panel, uyarılar ve destek. Oda sayısından bağımsız olarak otel başına aylık 99 $. İlk 30 gün içinde memnun kalmazsanız ücretin tamamını iade ederiz."],
        ["Kurulum ne kadar sürer?", "Otel bilgileriniz ve Google yorum bağlantınızla aynı gün açarız. QR kodları baskıya hazır olarak size iletiriz."],
        ["Personel yeni bir şey öğrenmek zorunda mı?", "Hayır. Resepsiyon bilgisayarında bir sekme açık kalır; düşük puan gelince ses ve bildirim çıkar."],
        ["Misafir verisi nerede tutuluyor?", "Yalnızca puan, mesaj ve oda numarası saklanır. Misafirden ad, telefon veya e-posta istenmez. Ayrıntılar gizlilik sayfamızda."],
      ],
    },
    demo: {
      eyebrow: "Ücretsiz demo", title: ["15 dakikada ", "otelinize özel", " gösterelim."],
      lede: "Formu doldurun; otelinizin adı ve logosuyla hazırlanmış misafir ekranını ve resepsiyon panelini canlı gösterelim.",
      ticks: ["Kredi kartı istenmez", "Kurulum aynı gün"],
      f: { name: "Ad soyad *", hotel: "Otel adı *", city: "Şehir", cityPh: "Muğla", rooms: "Oda sayısı", roomsPh: "ör. 48", phone: "Telefon", phonePh: "05xx xxx xx xx", email: "E-posta", note: "Not", notePh: "Size uygun arama saati, sorularınız…" },
      consent: "Demo planlamak amacıyla bu bilgilerle telefon veya e-posta yoluyla benimle iletişime geçilmesini kabul ediyorum.",
      privacy: "Gizlilik", submit: "Demo talebi gönder", sending: "Gönderiliyor…", reply: "Bir iş günü içinde dönüş yapıyoruz.",
      errContact: "Size ulaşabilmemiz için telefon veya e-posta yazın.", errConsent: "Devam etmek için iletişim onayını işaretleyin.", errSend: "Gönderilemedi. Lütfen tekrar deneyin.",
      okTitle: "Talebiniz alındı", okText: "Bir iş günü içinde sizinle iletişime geçip demoyu planlayacağız.",
    },
    footer: { login: "Otel girişi", contact: "İletişim", privacy: "Gizlilik" },
  },

  en: {
    nav: { how: "How it works", features: "Features", pricing: "Pricing", faq: "FAQ", login: "Hotel login", demo: "Book a demo" },
    mock: {
      welcome: "Welcome to", hotel: "Sample Hotel", q: "How is your stay so far?", word: "Below expectations",
      msg: "The AC isn't working, the room is too hot.", send: "Send to front desk", live: "LIVE", now: "now", room: "Room",
      qr: "SCAN · RATE", google: "New Google review", monogram: "S",
    },
    hero: {
      chip: "Guest feedback system for hotels",
      title: ["Fix the problem ", "before the guest checks out", "."],
      lede: "Guests scan the QR code in their room and rate their stay in 10 seconds. Unhappy guests reach your front desk instantly; happy guests leave a Google review with one tap.",
      cta: "Book a free demo", try: "Try the guest screen",
      ticks: ["Set up the same day", "No app for guests to download", "Turkish · English · Serbian"],
    },
    problem: {
      eyebrow: "The problem",
      title: ["Unhappy guests rarely tell ", "the front desk", ". They tell the internet."],
      items: [
        ["Everything looks fine at check-out", "Guests who don't want to complain in person leave quietly."],
        ["You learn about it from a review", "After the chance to fix it has passed, in public."],
        ["Happy guests forget to review", "Your best stays never reach Google."],
      ],
    },
    how: {
      eyebrow: "How it works", title: ["Four steps, ", "zero", " training."],
      steps: [
        ["QR in every room", "Each room gets its own QR stand. Guests scan it with their phone camera; nothing to install."],
        ["Rated in 10 seconds", "Guests give 1–5 stars. The room number comes from the QR code automatically."],
        ["Problems reach you instantly", "1–3 star ratings and messages appear on the front-desk screen with a sound alert, while the guest is still there."],
        ["Happy guests go to Google", "Guests who give 4–5 stars are taken to your Google review page with one tap."],
      ],
    },
    features: {
      eyebrow: "Features", title: ["Your front desk's ", "new ears."],
      lede: "The dashboard stays open in a browser tab. When a low rating arrives it plays a sound and shows the room number and the guest's message. Close it with one click once it's solved.",
      cta: "See the dashboard demo",
      items: [
        ["Live sound alerts", "Low ratings trigger a sound and show the room number."],
        ["Room-specific links", "No need to ask which room it came from."],
        ["Three languages", "Turkish, English and Serbian, matched to the guest's phone language."],
        ["Hotel dashboard", "Average rating, open and resolved requests on one screen."],
        ["No app", "Opens in the browser for guests; nothing to install for staff."],
        ["Policy-compliant", "Every guest can review you on Google at any time; nothing is filtered."],
      ],
    },
    policy: ["Compliant with Google's policies.", " RateGuard never filters reviews; every guest can post on Google whenever they like. We simply make sure an unhappy guest reaches you first."],
    pricing: {
      eyebrow: "Pricing", title: ["One plan, ", "everything included."],
      chip: "All features",
      bullets: ["QR codes for every room", "Live front-desk dashboard with sound alerts", "Google review routing", "Guest screen in Turkish, English and Serbian", "Setup and QR design included", "No contract, cancel any month"],
      badges: ["30-day money-back guarantee", "2 months free on annual billing"],
      cta: "Book a demo",
    },
    faq: {
      eyebrow: "FAQ", title: "Common questions",
      items: [
        ["Do you hide bad reviews from Google?", "No. Google's policies forbid selectively collecting reviews, and RateGuard doesn't do it. Guests who give a low rating also see the Google link. The difference is that their problem reaches you first, so you can fix it before they leave."],
        ["What's included in the price?", "Everything: QR design, setup, dashboard, alerts and support, for $99 per hotel per month regardless of room count. If you're not happy within 30 days, we refund you in full."],
        ["How long does setup take?", "We set you up the same day with your hotel details and Google review link, and send print-ready QR codes."],
        ["Does my staff need training?", "No. A browser tab stays open at reception; a sound and a notification appear when a low rating arrives."],
        ["Where is guest data stored?", "We store only the rating, message and room number. Guests are never asked for their name, phone or email. Details are on our privacy page."],
      ],
    },
    demo: {
      eyebrow: "Free demo", title: ["A 15-minute demo, ", "built for your hotel", "."],
      lede: "Fill in the form and we'll show you the guest screen and front-desk dashboard live, with your hotel's name and logo.",
      ticks: ["No credit card", "Same-day setup"],
      f: { name: "Full name *", hotel: "Hotel name *", city: "City", cityPh: "Budva", rooms: "Number of rooms", roomsPh: "e.g. 48", phone: "Phone", phonePh: "+382 …", email: "Email", note: "Note", notePh: "Best time to call, questions…" },
      consent: "I agree to be contacted by phone or email with these details to arrange a demo.",
      privacy: "Privacy", submit: "Request a demo", sending: "Sending…", reply: "We reply within one business day.",
      errContact: "Please add a phone number or email so we can reach you.", errConsent: "Please tick the consent box to continue.", errSend: "Couldn't send. Please try again.",
      okTitle: "Request received", okText: "We'll contact you within one business day to schedule your demo.",
    },
    footer: { login: "Hotel login", contact: "Contact", privacy: "Privacy" },
  },

  sr: {
    nav: { how: "Kako radi", features: "Funkcije", pricing: "Cena", faq: "Pitanja", login: "Prijava hotela", demo: "Zakažite demo" },
    mock: {
      welcome: "Dobro došli", hotel: "Primer Hotel", q: "Kako vam protiče boravak?", word: "Ispod očekivanja",
      msg: "Klima ne radi, u sobi je prevruće.", send: "Pošalji recepciji", live: "UŽIVO", now: "sada", room: "Soba",
      qr: "SKENIRAJ · OCENI", google: "Nova Google recenzija", monogram: "P",
    },
    hero: {
      chip: "Sistem za utiske gostiju za hotele",
      title: ["Rešite problem ", "pre nego što gost ode", "."],
      lede: "Gost skenira QR kod u sobi i ocenjuje boravak za 10 sekundi. Poruka nezadovoljnog gosta odmah stiže na recepciju; zadovoljan gost jednim dodirom ostavlja recenziju na Google-u.",
      cta: "Zakažite besplatan demo", try: "Isprobajte ekran za goste",
      ticks: ["Postavljanje istog dana", "Gost ne preuzima aplikaciju", "Turski · Engleski · Srpski"],
    },
    problem: {
      eyebrow: "Problem",
      title: ["Nezadovoljan gost retko kaže ", "recepciji", ". Kaže internetu."],
      items: [
        ["Na odjavi sve izgleda u redu", "Gost koji ne želi da se žali lično odlazi bez reči."],
        ["Za problem saznate iz recenzije", "Kada je prilika da ga rešite već prošla, i to javno."],
        ["Zadovoljni gosti zaborave recenziju", "Najbolji boravci nikada ne stignu do Google-a."],
      ],
    },
    how: {
      eyebrow: "Kako radi", title: ["Četiri koraka, ", "nula", " obuke."],
      steps: [
        ["QR u svakoj sobi", "Svaka soba dobija svoj QR stalak. Gost ga skenira kamerom telefona; ništa se ne instalira."],
        ["Ocena za 10 sekundi", "Gost daje 1–5 zvezdica. Broj sobe se automatski preuzima iz QR koda."],
        ["Problem odmah stiže do vas", "Ocene 1–3 i poruke pojavljuju se na ekranu recepcije uz zvučno upozorenje, dok je gost još u hotelu."],
        ["Zadovoljan gost ide na Google", "Gost koji da 4–5 zvezdica jednim dodirom stiže na vašu Google stranicu za recenzije."],
      ],
    },
    features: {
      eyebrow: "Funkcije", title: ["Nove uši ", "vaše recepcije."],
      lede: "Kontrolna tabla stoji otvorena u kartici pregledača. Kada stigne niska ocena, oglasi se zvuk i prikažu se broj sobe i poruka gosta. Kada rešite problem, zatvarate ga jednim klikom.",
      cta: "Pogledajte demo table",
      items: [
        ["Zvučna upozorenja uživo", "Niska ocena pokreće zvuk i prikazuje broj sobe."],
        ["Link za svaku sobu", "Ne morate da pitate iz koje sobe je stiglo."],
        ["Tri jezika", "Turski, engleski i srpski, prema jeziku gostovog telefona."],
        ["Tabla za hotel", "Prosečna ocena, otvoreni i rešeni zahtevi na jednom ekranu."],
        ["Bez aplikacije", "Za goste se otvara u pregledaču; osoblje ništa ne instalira."],
        ["U skladu s pravilima", "Svaki gost može bilo kada da ostavi recenziju na Google-u; ništa se ne filtrira."],
      ],
    },
    policy: ["U skladu s Google pravilima.", " RateGuard nikada ne filtrira recenzije; svaki gost može da piše na Google-u kad god želi. Mi samo obezbeđujemo da nezadovoljan gost prvo stigne do vas."],
    pricing: {
      eyebrow: "Cena", title: ["Jedan paket, ", "sve uključeno."],
      chip: "Sve funkcije",
      bullets: ["QR kodovi za sve sobe", "Tabla za recepciju sa zvučnim upozorenjima", "Usmeravanje na Google recenzije", "Ekran za goste na turskom, engleskom i srpskom", "Postavljanje i dizajn QR kodova uključeni", "Bez ugovorne obaveze, otkazujete bilo kog meseca"],
      badges: ["30 dana garancija povraćaja novca", "2 meseca gratis uz godišnje plaćanje"],
      cta: "Zakažite demo",
    },
    faq: {
      eyebrow: "Pitanja", title: "Česta pitanja",
      items: [
        ["Da li skrivate loše recenzije od Google-a?", "Ne. Google pravila zabranjuju selektivno prikupljanje recenzija i RateGuard to ne radi. I gost koji da nisku ocenu vidi link ka Google-u. Razlika je u tome što njegov problem prvo stigne do vas, pa ga možete rešiti pre odlaska."],
        ["Šta je uključeno u cenu?", "Sve: dizajn QR kodova, postavljanje, tabla, upozorenja i podrška, za 99 € mesečno po hotelu, bez obzira na broj soba. Ako niste zadovoljni u roku od 30 dana, vraćamo ceo iznos."],
        ["Koliko traje postavljanje?", "Sa podacima hotela i vašim Google linkom za recenzije postavljamo sve istog dana i šaljemo QR kodove spremne za štampu."],
        ["Da li osoblje mora da prođe obuku?", "Ne. Na recepciji ostaje otvorena jedna kartica pregledača; kada stigne niska ocena, oglasi se zvuk i obaveštenje."],
        ["Gde se čuvaju podaci gostiju?", "Čuvamo samo ocenu, poruku i broj sobe. Od gosta se nikada ne traže ime, telefon ili e-pošta. Detalji su na stranici o privatnosti."],
      ],
    },
    demo: {
      eyebrow: "Besplatan demo", title: ["Demo od 15 minuta, ", "za vaš hotel", "."],
      lede: "Popunite formular i uživo ćemo vam pokazati ekran za goste i tablu za recepciju sa imenom i logotipom vašeg hotela.",
      ticks: ["Bez kreditne kartice", "Postavljanje istog dana"],
      f: { name: "Ime i prezime *", hotel: "Naziv hotela *", city: "Grad", cityPh: "Budva", rooms: "Broj soba", roomsPh: "npr. 48", phone: "Telefon", phonePh: "+382 …", email: "E-pošta", note: "Napomena", notePh: "Najbolje vreme za poziv, pitanja…" },
      consent: "Slažem se da me kontaktirate telefonom ili e-poštom sa ovim podacima radi zakazivanja demoa.",
      privacy: "Privatnost", submit: "Pošaljite zahtev za demo", sending: "Šalje se…", reply: "Odgovaramo u roku od jednog radnog dana.",
      errContact: "Unesite telefon ili e-poštu kako bismo vas kontaktirali.", errConsent: "Označite saglasnost da biste nastavili.", errSend: "Slanje nije uspelo. Pokušajte ponovo.",
      okTitle: "Zahtev je primljen", okText: "Javićemo vam se u roku od jednog radnog dana da zakažemo demo.",
    },
    footer: { login: "Prijava hotela", contact: "Kontakt", privacy: "Privatnost" },
  },
};
